module.exports = __webpack_public_path__ + "img/sshx6.d1ba5888.png";